import { render, staticRenderFns } from "./vehicle-driver-info-detail-modal.vue?vue&type=template&id=22a34a78"
import script from "./vehicle-driver-info-detail-modal.vue?vue&type=script&lang=js"
export * from "./vehicle-driver-info-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports